import { AppEnvironments } from '@models/app-environments';

export const environment = {
  environment: AppEnvironments.stage,
  apiUrl: 'https://stage-zbportal-linux.azurewebsites.net',
  proxyApiUrl: 'https://stage-api-management-zbportal.azure-api.net',
  assetUrl: 'https://stage-cdn.zaner-bloser.com/',
  skofUrl: 'https://stage-cdn.zaner-bloser.com',
};
